<!--合作伙伴-->
<template>
  <div class="new-box">
    <div class="page-banner flex-column-c-c">
      <div class="red-zz"></div>
      <div class="banner-title">合作伙伴</div>
      <div class="banner-line"></div>
    </div>
    <div class="swiper-box">
      <div class="staff-header">
        <div class="font70">PARTNER</div>
        <div class="font50">合作伙伴</div>
      </div>
      <div class="swiper-list">
        <swiper class="w100per" :options="documentWidth < 750 ? swiperOptionApp : swiperOption" ref="mySwiper">
          <swiper-slide class="swiper-item" v-for="(item,index) in logoList" :key="index">
            <a target="_blank" :href="item.link_url" class="banner-item">
              <div class="item-header flex-c-sb">
                <div class="header-logo" v-if="item.image"><img class="img-height" :src="`${ajaxUrl}${item.image}`" alt=""></div>
                <div class="header-title">{{item.title}}</div>
              </div>
              <div class="item-con">
                {{item.description}}
              </div>
            </a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
<!--    <MessageFrom></MessageFrom>-->
    <Footer></Footer>
  </div>
</template>

<script>
  import MessageFrom from "../components/MessageFrom";
  import {ajaxPost,ajaxUrl} from "../utils/ajax";
  import Footer from "../components/Footer";
  export default {
    name: "Partner",
    data(){
      return {
        ajaxUrl,
        newsPage:{
          currentPage: 1,
          pageSize: 4,
          total: 45,
        },
        logoList:[],
        swiperOption:{
          autoplay: {
            disableOnInteraction: false,
            delay: 5000,
          },
          slidesPerView: 3,
          spaceBetween: 20,
          direction: 'vertical',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          loop: true,
        },
        swiperOptionApp:{
          loop: true,
          autoplay: {
            disableOnInteraction: false,
            delay: 5000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        documentWidth: document.body.clientWidth,
      }
    },
    components: {Footer, MessageFrom},
    mounted() {
      this.$emit('handleRed', false);
      this.fetchList();
    },
    methods: {
      fetchList(){
        ajaxPost({
          url: 'ajaxPartner',
          success(res){
            const {data, code, msg} = res;
            if(code === 200){
              this.logoList = data.partner_list;
            } else {
              this.$message.warning(msg)
            }
          }
        }, this)
      },
    },
  }
</script>

<style scoped lang="scss">
  .new-box {
    width: 100%;background: $color-white;
    .page-banner {
      width: 100%;height: 610px;background: url('../assets/partner/partner_banner.png') no-repeat center/cover;padding-top: 2%;position: relative;
      .red-zz { position: absolute;width: 100%;height: 240px;background: linear-gradient(180deg,rgba($theme-color,.7),transparent);top: 0;left: 0;z-index: 2;}
      .banner-title { font-size: 60px;color: $color-white;letter-spacing: 1px;}
      .banner-line { width: 110px;height: 3px;background: $color-white;margin-top: 50px;}
    }
    .swiper-box {
      width: 100%;padding: 80px 105px;background: url("../assets/common_bg.png") no-repeat top -90px left;
      .staff-header {
        color: $theme-color;line-height: 1.3;
      }
      .swiper-list {
        background: #fff;margin-top: 80px;padding: 60px 20px 85px 20px;position: relative;
        >>> .swiper-container { height: 810px;}
        >>> .swiper-slide { padding: 50px 0;position: static;}
        >>> .swiper-button-next {
          width: 38px;height: 38px;border-radius: 50%;border: 1px solid $theme-color;padding: 0;line-height: 38px;bottom: 0;top: auto;right: 50px;
          &:after { font-size: 20px;color: $theme-color}
          &:hover {
            background: $theme-color;
            &:after { color: #fff;}
          }
        }
        >>> .swiper-button-prev {
          min-width: 38px;height: 38px;border-radius: 50%;border: 1px solid $theme-color;padding: 0;line-height: 38px;bottom: 0;top: auto;right: 110px;left: auto;
          &:after { font-size: 20px;color: $theme-color}
          &:hover {
            background: $theme-color;
            &:after { color: #fff;}
          }
        }
        .banner-item {
          width: 100%;background: #F3F3F3;padding: 30px 22px;cursor: pointer;transition: .2s;
          &:hover { color: $theme-color;transform: translateY(-4px)}
          .item-header {
            background: #fff;box-shadow: 0 -8px 22px 0 rgba(0,0,0,0.08);margin-top: -50px;min-height: 80px;
            .header-logo { padding: 4px 0 4px 20px;height: 80px;}
            .header-title { padding: 0 65px;font-size: 24px;letter-spacing: 1px;border-left: 1px solid #DCDCDC;height: 100%;}
          }
          .item-con { margin-top: 30px;width: 100%;font-size: $font-size16;line-height: 1.8;text-indent: 2em;}

        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .new-box {
      .page-banner {
        height: 220px;padding-bottom: 0;padding-top: 4%;
        .banner-title { font-size: 26px;position: relative;z-index: 3;}
        .banner-line { width: 50px;height: 2px;margin-top: 10px;position: relative;z-index: 3;}
      }
      .swiper-box {
        padding: 20px 14px;
        .staff-header {
          padding: 0;margin: 5px 0;
          .font70 { font-size: 32px;word-spacing: -1px;}
          .font50 { font-size: 24px;}
        }
        .swiper-list {
          margin-top: 14px;padding: 0;background: transparent;
          >>> .swiper-container { height: auto;}
          >>> .swiper-slide { padding: 36px 0 20px 0;position: static;}
          >>> .swiper-button-next {
            width: 26px;height: 26px;line-height: 26px;top: -20px;right: 0;
            &:after { font-size: 14px;color: $theme-color}
          }
          >>> .swiper-button-prev {
            min-width: 26px;width: 26px;height: 26px;line-height: 26px;top: -20px;right: 40px;
            &:after { font-size: 14px;color: $theme-color}
          }
          .banner-item {
            padding: 10px;
            &:hover { color: $theme-color;transform: translateY(0)}
            .item-header {
              min-height: 0;box-shadow: none;padding: 10px;margin-top: -40px;
              .header-logo { padding: 0;height: 50px;}
              .header-title { padding: 0;font-size: 16px;border: none;height: auto;}
            }
            .item-con { margin-top: 14px;font-size: 14px;max-height: 225px;overflow: hidden;}
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Partner.vue